import React, { useCallback, useState } from "react";
import { Page, Card, Tabs } from "@shopify/polaris";

import SolrFiltersConfig from "./components/SolrFilters/SolrFiltersConfig";
import FiltersDef from "./components/SolrFilters/FiltersDef";
import store from "store-js";

function SolrFilters() {

  const currentTab = store.get("solrFiltersTab") || 0;
  const [selected, setSelected] = useState(currentTab);

  store.set("solrFiltersTab", selected);

  const handleTabChange = useCallback((index) => setSelected(index), []);

  const tabs = [
    {
      id: "solrFiltersConfig",
      title: "SOLR Filters",
      content: "Collection Filters",
      page: <SolrFiltersConfig />,
      panelID: "solrFiltersConfigPanel",
    },
    {
      id: "filtersDef",
      title: "SOLR Filters",
      content: "Filters Definitions",
      page: <FiltersDef />,
      panelID: "filtersDefPanel",
    },
  ];

  return (
    <Page breadcrumbs={[{ url: "/" }]} title={tabs[selected].title} fullWidth>
      <Card>
        <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
          {tabs[selected].page}
        </Tabs>
      </Card>
    </Page>
  );
}

export default SolrFilters;
